import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import CanvasJSReact from '@canvasjs/react-charts';
const { CanvasJSChart } = CanvasJSReact;

const Dashboard = () => {

    const { response, error } = useSelector((state) => state.getUsersData);

    const { response: usersCountResponse, error: usersCountError } = useSelector((state) => state.usersCount);

    const { response: pieChart1Response, error: pieChart1Error } = useSelector((state) => state.ordersForSuppliers);

    const { response: pieChart2Response, error: pieChart2Error } = useSelector((state) => state.supplierOrdersDashboard);

    const [period, setPeriod] = useState('weekly');

    const [periodPieChart1, setPeriodPieChart1] = useState('weekly');

    const [periodPieChart2, setPeriodPieChart2] = useState('weekly');

    const [graphData, setGraphData] = useState([]);

    const [pieChart1Data, setPieChart1Data] = useState([]);

    const [pieChart2Data, setPieChart2Data] = useState([]);

    // Handle filter change for bar graph
    const handleFilterChange = (event) => {
        setPeriod(event.target.value);
    };

    // Handle filter change for pie chart 1
    const handleFilterChange2 = (event) => {
        setPeriodPieChart2(event.target.value);
    };

    // Handle filter change for pie chart 2
    const handleFilterChange1 = (event) => {
        setPeriodPieChart1(event.target.value);
    };

    // Function to format graph data based on selected period
    const formatGraphData = useCallback((period) => {
        if (!response) return [];
        let data = [];
        if (period == 'weekly') {
            data = response?.data?.weekly;
        } else if (period == 'monthly') {
            data = response?.data?.monthly;
        } else if (period == 'yearly') {
            data = response?.data?.yearly;
        }

        return data?.map(item => ({
            label: item.date,
            count: item.count
        }));
    }, [response]);

    const formatPieChart1Data = useCallback((period) => {
        if (!pieChart1Response) return [];
        let data = [];
        if (period == 'weekly') {
            data = pieChart1Response?.data?.weekly;
        } else if (period == 'monthly') {
            data = pieChart1Response?.data?.monthly;
        } else if (period == 'yearly') {
            data = pieChart1Response?.data?.yearly;
        }

        return data?.map(item => ({
            label: item.label,
            count: item.value
        }));
    }, [pieChart1Response]);

    const formatPieChart2Data = useCallback((period) => {
        if (!pieChart2Response) return [];
        let data = [];
        if (period == 'weekly') {
            data = pieChart2Response?.data?.weekly;
        } else if (period == 'monthly') {
            data = pieChart2Response?.data?.monthly;
        } else if (period == 'yearly') {
            data = pieChart2Response?.data?.yearly;
        }

        return data?.map(item => ({
            label: item.label,
            count: item.value
        }));
    }, [pieChart2Response]);


    // Set pie chart 1 data when period changes
    useEffect(() => {
        const data = formatPieChart1Data(periodPieChart1);
        setPieChart1Data(data);
    }, [periodPieChart1, pieChart1Response]);

    //  Set pie chart 2 data when period changes
    useEffect(() => {
        const data = formatPieChart2Data(periodPieChart2);
        setPieChart2Data(data);
    }, [periodPieChart2, pieChart2Response]);

    // Set graph data when period changes
    useEffect(() => {
        const data = formatGraphData(period);
        setGraphData(data);
    }, [period, response]);


    const options = useMemo(() => ({
        animationEnabled: true,
        theme: "light2",
        // title: {
        //     text: "Users Data"
        // },
        axisY: {
            title: "Number of Users",
            includeZero: true
        },
        data: [
            {
                type: "column",
                name: "Users",
                showInLegend: true,
                color: "#94D23D",
                dataPoints: graphData.length > 0 ? graphData.map(item => ({ label: item.label, y: item.count })) : [{ label: "No Data", y: 0, color: "#f0f0f0", toolTipContent: "No data available" }]
            }
        ]
    }), [graphData]);


    const pieColors = ["#94D23D", "#0052FF", "#FD957A"];
    const options1 = useMemo(() => ({
        animationEnabled: true,
        theme: "light2",
        // axisY: {
        //     title: "Number of Users",
        //     includeZero: true
        // },
        data: [
            {
                type: "doughnut",
                name: "Users",
                showInLegend: pieChart1Data.length > 0,
                // color: "#94D23D",
                innerRadius: "60",
                dataPoints: pieChart1Data.length > 0
                    ? pieChart1Data.map((item, index) => ({
                        label: item.label,
                        y: item.count,
                        name: item.label == 'Accepted' ? 'Accepted' : 'Rejected',
                        color: pieColors[index % pieColors.length]
                    }))
                    : [{ label: "No Data", y: 1, color: "#f0f0f0", toolTipContent: "No data available" }]
            }
        ]
    }), [pieChart1Data]);

    const options2 = useMemo(() => ({
        animationEnabled: true,
        theme: "light2",
        // title: {
        //     text: "Users Data"
        // },
        axisY: {
            title: "Number of Users",
            includeZero: true
        },
        data: [
            {
                type: "doughnut",
                name: "Users",
                showInLegend: pieChart2Data.length > 0,
                color: "#94D23D",
                dataPoints: pieChart2Data.length > 0
                    ? pieChart2Data.map((item, index) => ({
                        label: item.label, y: item.count, name: item.label,
                        color: pieColors[index % pieColors.length]
                    }))
                    : [{ label: "No Data", y: 1, color: "#f0f0f0", toolTipContent: "No data available" }]
            }
        ]
    }), [pieChart2Data]);

    return (
        // <div style={{ height: '70vh' }} className='d-flex align-items-center justify-content-center text-center'>
        //     <PuffLoader size={85} color="#0f0a30" />
        // </div>

        <div className="content-wrapper">
            <section className="common-section spacer">
                <div className="container">
                    <div className="dashboard-card-wrapper">
                        <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-xl-4 row-cols-xxl-5 g-4">
                            {/* <div className="col">
                                <div className="dashboard-card-item">
                                    <div className="dashboard-card-content">
                                        <div className="dashboard-card-info">
                                            <h2>Farmers</h2>
                                            <p>40,689</p>
                                        </div>
                                        <div className="dashboard-card-icon">
                                            <img src="assets/icons/farmer-icon.png" alt="Icon" />
                                        </div>
                                    </div>
                                </div>
                            </div> */}
                            <div className="col">
                                <div className="dashboard-card-item">
                                    <div className="dashboard-card-content">
                                        <div className="dashboard-card-info">
                                            <h2>Suppliers</h2>
                                            <p>{usersCountResponse?.data?.suppliers[0]?.total || 0}</p>
                                        </div>
                                        <div className="dashboard-card-icon">
                                            <img src="assets/icons/supplier-icon.png" alt="Icon" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col">
                                <div className="dashboard-card-item">
                                    <div className="dashboard-card-content">
                                        <div className="dashboard-card-info">
                                            <h2>Restaurants</h2>
                                            <p>{usersCountResponse?.data?.restaurants[0]?.total || 0}</p>
                                        </div>
                                        <div className="dashboard-card-icon">
                                            <img src="assets/icons/restaurant-icon.png" alt="Icon" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col">
                                <div className="dashboard-card-item">
                                    <div className="dashboard-card-content">
                                        <div className="dashboard-card-info">
                                            <h2>Customers</h2>
                                            <p>{usersCountResponse?.data?.customers[0]?.total || 0}</p>
                                        </div>
                                        <div className="dashboard-card-icon">
                                            <img src="assets/icons/customer-icon.png" alt="Icon" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <div className="col">
                                <div className="dashboard-card-item">
                                    <div className="dashboard-card-content">
                                        <div className="dashboard-card-info">
                                            <h2>Guest Users</h2>
                                            <p>0</p>
                                        </div>
                                        <div className="dashboard-card-icon">
                                            <img src="assets/icons/guest-icon.png" alt="Icon" />
                                        </div>
                                    </div>
                                </div>
                            </div> */}
                        </div>
                    </div>
                    <div className="graph_wrapper">
                        <div className="row">
                            <div className="col-md-12 col-lg-7">
                                <div className="graph-cards bg-white">
                                    <div className="graph-cards-top-blk">
                                        <h2 className="txt-heading-clr">Users Registerd</h2>
                                        <div className="select-field-wrapper">
                                            <div className="select-field-inner-blk position-relative">
                                                <select className="form-select select-dropdown" value={period}
                                                    onChange={handleFilterChange}>
                                                    <option value="weekly">This Week</option>
                                                    <option value="monthly">This Month</option>
                                                    <option value="yearly">This Year</option>
                                                </select>
                                                <span className='cal_icon'><img src='assets/icons/cal-icon.png' /></span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="wrapper-graph">
                                        {/* <img src="assets/images/dash-order-img-1.png" alt="graph" /> */}
                                        <CanvasJSChart options={options} />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12 col-lg-5">
                                <div className="graph-cards bg-white">
                                    <div className="graph-cards-top-blk">
                                        <h2 className="txt-heading-clr">Orders for Suppliers</h2>
                                        <div className="select-field-wrapper">
                                            <div className="select-field-inner-blk position-relative" value={periodPieChart1}
                                                onChange={handleFilterChange1}>
                                                <select className="form-select select-dropdown">
                                                    <option value="weekly">This Week</option>
                                                    <option value="monthly">This Month</option>
                                                    <option value="yearly">This Year</option>
                                                </select>
                                                <span className='cal_icon'><img src='assets/icons/cal-icon.png' /></span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="wrapper-graph">
                                        {/* <img src="assets/images/dash-order-img.png" alt="graph" /> */}
                                        <CanvasJSChart options={options1} />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12 col-lg-5 py-5">
                                <div className="graph-cards bg-white">
                                    <div className="graph-cards-top-blk">
                                        <h2 className="txt-heading-clr">Orders for Farmers</h2>
                                        <div className="select-field-wrapper">
                                            <div className="select-field-inner-blk position-relative">
                                                <select className="form-select select-dropdown" value={periodPieChart2}
                                                    onChange={handleFilterChange2}>
                                                    <option value="weekly">This Week</option>
                                                    <option value="monthly">This Month</option>
                                                    <option value="yearly">This Year</option>
                                                </select>
                                                <span className='cal_icon'><img src='assets/icons/cal-icon.png' /></span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="wrapper-graph">
                                        {/* <img src="assets/images/dash-order-img-2.png" alt="graph" /> */}
                                        <CanvasJSChart options={options2} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>


    )
}

export default Dashboard